/* eslint-disable array-callback-return */

import { observable, action, makeObservable } from "mobx";
import api from "../api/api";
import {
  CustomerDiagnosis,
  CustomerDiagnosisJourneyStep,
} from "../model/CustomerDiagnosis";
import { IDiagnosticStep } from "../model/DiagStep";
import {
  device,
  ICreateCustDiagnosticsRequest,
  ICreateCustDiagnosticsResponse,
  IGetResolutionRequest,
  operatingSystem,
  problem,
} from "../model/dto";
import { ResolutionObj } from "../model/Resolution";
import { RootStore } from "./RootStore";

export class CustDiagStore {
  root: RootStore;

  @observable currentCustDiag: CustomerDiagnosis = {} as CustomerDiagnosis;
  @observable isLoading: boolean = false;
  @observable currentDiagnosticStep: IDiagnosticStep | undefined;
  @observable currentStage: number = 1;
  @observable deviceList: device[] = [];
  @observable problemList: problem[] = [];
  @observable osList: operatingSystem[] = [];
  @observable resolution: ResolutionObj = {} as ResolutionObj;

  constructor(root: RootStore) {
    this.root = root;
    makeObservable(this);
    this.currentCustDiag.wizardSteps = [];
  }

  @action addCustDigJourney(
    selectedAnswer: string,
    stepId: string,
    stepText: string
  ) {
    var journeyLog = {} as CustomerDiagnosisJourneyStep;

    journeyLog.diagnosticStepAnswer = selectedAnswer;
    journeyLog.diagnosticStepId = stepId;
    journeyLog.diagnosticStepText = stepText;

    if (this.currentCustDiag.wizardSteps === undefined) {
      this.currentCustDiag.wizardSteps = [];
    }

    this.currentCustDiag.wizardSteps.push(journeyLog);
  }

  @action startNewDiagnostic() {
    this.isLoading = true;
    this.currentCustDiag = {} as CustomerDiagnosis;
    this.isLoading = false;
  }

  @action setCurrentDiagStep(step: IDiagnosticStep) {
    this.currentDiagnosticStep = step;
  }

  @action getDeviceTypes() {
    this.isLoading = true;
    api.InitialProblem.getDevicetypes().then(
      (resp) => {
        this.deviceList = resp.devices;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        alert(error.message);
      }
    );
  }

  @action getProblemTypes() {
    this.problemList = [];
    console.log(this.currentCustDiag.devicetypeId);
    api.InitialProblem.getProblemtypes(this.currentCustDiag.devicetypeId).then(
      (resp) => {
        this.isLoading = true;
        this.problemList = resp.problems;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        alert(error.message);
      }
    );
  }

  @action getOSTypes() {
    api.InitialProblem.getOStypes(
      this.currentCustDiag.devicetypeId,
      this.currentCustDiag.problemId
    ).then(
      (resp) => {
        this.isLoading = true;
        this.osList = resp.operatingsystems;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        alert(error.message);
      }
    );
  }

  @action async getResolutionDetails(linkId: string) {
    this.isLoading = true;
    api.Resolution.getResolutionDetails({
      linkId: linkId,
    } as IGetResolutionRequest).then(
      (resp) => {
        this.resolution = resp.res;
        this.isLoading = false;
        console.log(resp);
      },
      (error) => {
        this.isLoading = false;
        alert(error.message);
      }
    );
  }

  @action async createCustomerDiagnosis() {
    this.isLoading = true;

    api.CustDiagnosis.createCustomerDiagnosis({
      custDiag: this.currentCustDiag,
      res: this.currentDiagnosticStep?.diagnosisStepId,
    } as ICreateCustDiagnosticsRequest).then(
      (resp: ICreateCustDiagnosticsResponse) => {
        if (resp.result == true) {
          this.isLoading = false;
          console.log(resp.result);
        } else {
          this.isLoading = false;
          alert(resp);
        }
      },
      (error) => {
        this.isLoading = false;
        alert(error.message);
      }
    );
  }

  @action setCurrentStage(stage: number) {
    this.currentStage = stage;
  }

  @action async startDiagnosis() {
    if (
      this.currentCustDiag.devicetypeId !== undefined &&
      this.currentCustDiag.operatingSystemId !== undefined &&
      this.currentCustDiag.problemId !== undefined
    ) {
      this.isLoading = true;

      api.InitialProblem.getPrimaryIssueStartStep(
        this.currentCustDiag.devicetypeId,
        this.currentCustDiag.problemId,
        this.currentCustDiag.operatingSystemId
      ).then(
        (resp) => {
          this.isLoading = false;
          this.getNextDiagnosticStep(resp.primaryIssueStartStep, "");
        },
        (error) => {
          alert("Error: " + error.message);
        }
      );
    } else {
      alert(
        "We need all the fields filled in to correctly diagnose your issue!"
      );
    }
  }

  @action async getNextDiagnosticStep(stepId: number, stepText: string) {
    this.isLoading = true;

    if (this.currentDiagnosticStep?.diagnosisStepId !== undefined) {
      this.addCustDigJourney(
        stepText,
        this.currentDiagnosticStep?.diagnosisStepId || "",
        this.currentDiagnosticStep?.text || ""
      );
    }
    var diagStep = (await api.DiagnosticStep.getDiagnosticStep(
      stepId
    )) as IDiagnosticStep;
    this.isLoading = false;

    this.setCurrentDiagStep(diagStep);
    this.setCurrentStage(2);
  }
}
